const bookList = [
  {
    name: 'The Immortal Life of Henrietta Lacks',
    description: 'A fascinating look at one woman\'s groundbreaking, unwitting contributions to modern-day medicine and the questions they raised around bioethics and exploitation.',
    author: 'Rebecca Skloot',
    imageCover: 'immortal-life-of-henrietta-lacks',
  },
  {
    name: 'Being Mortal',
    description: 'Being Mortal explores the challenges of aging and the approach towards end-of-life patients. Dr. Gawande shares patient and family experiences to argue for prioritizing well-being over survival in medical care.',
    author: 'Dr. Atul Gawande',
    imageCover: 'being-mortal',
  },
];

const bookCard = document.querySelector('.feature-img');

export default function loadBook() {
  const selectedBook = bookList[Math.floor(Math.random() * bookList.length)];
  const {
    name, author, description, imageCover,
  } = selectedBook;
  const bookCardInner = `<picture>
    <source class="lazy-image" type="image/webp"
        data-srcset="https://assets.wellreceived.com/wellreceived/website/webp/desktop/illustrations/${imageCover}@2x.webp" />
    <source class="lazy-image"
        data-srcset="https://assets.wellreceived.com/wellreceived/website/images/desktop/illustrations/${imageCover}.png 1x, https://assets.wellreceived.com/wellreceived/website/images/desktop/illustrations/${imageCover}.png 2x" />
    <img loading="lazy" src="https://assets.wellreceived.com/wellreceived/website/images/desktop/illustrations/${imageCover}.png"
        alt=${name} width="210" height="320"/>
    </picture>
    <figcaption class="inset-left-md fx fx--c book-details desktop-only">
        <div>
            <h3 class="text text--md text--bold inset-right-md mb-1">${name}</h3>
            <span class="author text text--sm tc-grey">${author}</span>
        </div>
        <p class="text text--md mt-10 summary">${description}</p>
    </figcaption>`;
  bookCard.innerHTML = bookCardInner;
}
